module.exports = __webpack_public_path__ + "img/search-disabled.ee88cf95.svg";